import { createSharedComposable } from '@vueuse/core';

// eslint-disable-next-line regex/invalid
import { AuthModal, SessionExpiredModal } from '#components';
import type { AuthModalProps } from '~/components/Auth/AuthModal.vue';

type UseModalsReturn = {
    openAuthModal: (props?: AuthModalProps) => Promise<boolean>;
    closeAuthModal: () => void;

    openSessionExpiredModal: () => void;
    closeSessionExpiredModal: () => void;
};

export const _useModals = (): UseModalsReturn => {
    const overlay = useOverlay();

    // MODALS
    const authModal = overlay.create(AuthModal);
    const sessionExpiredModal = overlay.create(SessionExpiredModal);

    return {
        openAuthModal: props =>
            authModal.isOpen
                ? Promise.resolve(false)
                : authModal.open(
                      props ?? {
                          email: undefined,
                          action: undefined,
                      }
                  ),
        closeAuthModal: () => authModal.close(),

        openSessionExpiredModal: () => sessionExpiredModal.open(),
        closeSessionExpiredModal: () => sessionExpiredModal.close(),
    };
};

export const useModals = createSharedComposable(_useModals);
